function attachCustomFeatureNameModal () {
  const customFeatureNameElements = document.querySelectorAll('.rename-feature')
  const customFeatureNameModalForm = document.querySelector('#customFeatureNameModal form')

  if (!customFeatureNameModalForm) {
    return
  }

  customFeatureNameElements.forEach((customFeatureNameElement) => {
    customFeatureNameElement.addEventListener('click', clickCustomFeatureNameModal)
  })

  customFeatureNameModalForm.addEventListener('submit', submitCustomFeatureNameModal)
}

function clickCustomFeatureNameModal (evt) {
  evt.preventDefault()
  const dataKey = evt.target.getAttribute('data-rename-key')
  if (dataKey) {
    const headerTranslationKeyInput = document.querySelector('#customFeatureNameModal.modal input[name="key"]')
    headerTranslationKeyInput.value = dataKey
    $('#customFeatureNameModal').modal('show')
  }
}

function submitCustomFeatureNameModal (evt) {
  evt.preventDefault()
  const form = evt.target
  const formAction = form.getAttribute('action')
  const formData = new FormData(form)

  fetch(formAction, {
    method: 'POST',
    body: formData
  }).then(function (_data) {
    window.location.reload()
  }).catch(function (error) {
    window.flash('error', 'Error', error)
  })
}

document.addEventListener('DOMContentLoaded', function () {
  attachCustomFeatureNameModal()
})
